import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';


export default function ManuDetails({ manu }) {
  
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };


  return (

    <div style={{ marginLeft: '28px' }} >

    <Grid container  >
        <Grid item lg={12} md={12} sm={12} xs={12} >
          <p style={{fontSize: '14px', fontWeight: 600}}>{manu.documentTitle}</p>
        </Grid>

        <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}}>
          <div style={{ marginTop: '-14px' }}>
            <p style={{ fontSize: '12px', fontWeight: '500' }}>AUTHOR/SENDER </p>
            <p style={{ fontSize: '12px', fontWeight: '400', marginTop: '-13px' }}>{manu.author} </p>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}}>
          <div style={{ marginTop: '-15px' }}>
            <p style={{ fontSize: '12px', fontWeight: '500' }}>RECIPIENT </p>
            <p style={{ fontSize: '12px', fontWeight: '400', marginTop: '-13px',  marginRight: '25px' }}>{manu.recipient}</p>
          </div>
        </Grid>

        <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}}>
          <div style={{ marginTop: '-15px' }}>
            <p style={{ fontSize: '12px', fontWeight: '500' }}>DATE OF WRITING</p>
            <p style={{ fontSize: '12px', fontWeight: '400', marginTop: '-13px'  }}>{manu.dateOfWriting}  </p>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}} >
          <div style={{ marginTop: '-15px' }}>
            <p style={{ fontSize: '12px', fontWeight: '500' }}>LANGUAGE </p>
            <p style={{ fontSize: '12px', fontWeight: '400',  marginTop: '-13px'  }}> {manu.language}</p>
          </div>
        </Grid>
      </Grid>
       
        {isReadMore ?
          <div>
            <p onClick={toggleReadMore} style={{marginLeft: '373px', fontFamily: 'Montserrat', color: '#333333', fontSize: '12px', fontWeight: '500', cursor: 'pointer', marginTop: '3px'}}>
              {isReadMore ? "Show more" : "Show less"}
            </p>
          </div> :
        <div>
         <Grid container >   
          
            <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}}>
              <div style={{ marginTop: '-15px' }}>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>ARCHIVE/LIBRARY </p>
                <p style={{ fontSize: '12px', fontWeight: '400',  marginTop: '-13px', marginRight: '15px'  }}>{manu.archive}</p>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6} style={{marginTop: '-7px'}}>
              <div style={{ marginTop: '-15px' }}>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>LINK</p>
                <p style={{ fontSize: '12px', fontWeight: '400',  marginTop: '-13px', wordWrap: 'break-word', marginRight: '25px' }}> {manu.link}</p>
              </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} style={{marginTop: '-7px'}} >
              <div style={{ marginTop: '-15px' }}>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>RELATED DOCS</p>
                <Box bgcolor="white" style={{ minHeight: "60px", width: '438px' }} >
                <p style={{ fontSize: '12px', fontWeight: '400', marginTop: '-13px', marginBottom: '35px' }}>{manu.relatedDocuments}</p>
                </Box>
              </div>
            </Grid>
         

            <Grid item lg={12} md={12} sm={12} xs={12} style={{marginTop: '-7px'}}>
              <div style={{ marginTop: '-35px' }}>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>SUMMARY</p>
              </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} >
              <Box bgcolor="#F2F2F2" style={{ width: '440px', marginBottom: '15px' }} >
                <p style={{ fontFamily: 'Montserrat', fontWeight: 400, fontSize: '12px', padding: '8px', marginTop: '-8px' }}>
                  {manu.summary}
                </p>
              </Box>
            </Grid>
            <p onClick={toggleReadMore} style={{marginLeft: '379px', fontFamily: 'Montserrat', color: '#333333', fontSize: '12px', fontWeight: '500', cursor: 'pointer', marginTop: '3px'}}>
                {isReadMore ? "Show more" : " Show less"}
            </p>
      </Grid>
      </div>}
    </div>

  );
}
